<script>
  import Common from '../js/common.js';

  export let value;
</script>

<div class='markdown-box'>
  {@html Common.escapeMarkdown(value, true)}
</div>

<style>
  .markdown-box {
    line-height: 1.4;

    overflow-wrap: anywhere;
  }
</style>
